import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductMonitor16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44771 7 7 7.44772 7 8C7 8.55228 7.44771 9 8 9Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.94159 7.48074C4.84021 6.11325 6.27348 4.75 8.00001 4.75C9.72655 4.75 11.1598 6.11325 12.0584 7.48074C12.2408 7.7583 12.3276 8.07853 12.1431 8.38592C12.1402 8.39072 12.1402 8.39072 12.1431 8.38592C11.2778 9.81952 9.74998 11.25 8.00001 11.25C6.27349 11.25 4.84024 9.88682 3.9416 8.51935C3.72412 8.18841 3.7195 7.81872 3.94159 7.48074ZM10.5904 8.00004C9.9838 7.18928 9.08151 6.25 8.00001 6.25C6.91851 6.25 6.01623 7.18928 5.40963 8.00004C6.01624 8.81078 6.91852 9.75 8.00001 9.75C9.0815 9.75 9.98379 8.81078 10.5904 8.00004Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 9.59377 14.1976 11.0585 13.2739 12.2133L15.5303 14.4697L14.4696 15.5303L12.2132 13.2739C11.0585 14.1977 9.59375 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.27208 4.27208 1.25 8 1.25ZM13.25 8C13.25 5.10051 10.8995 2.75 8 2.75C5.1005 2.75 2.75 5.10051 2.75 8C2.75 10.8995 5.1005 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8Z'
      fill='currentColor'
    />
  </Svg>
);

ProductMonitor16.displayName = 'ProductMonitor16';
export default ProductMonitor16;
